import { TinaMarkdown } from "tinacms/dist/rich-text";

export default function Markdown({ content }) {
  return (
    <div className="markdown">
      <TinaMarkdown content={content} />
    </div>
  );
}
